<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Credit Invoice</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.credit_log_action_id"
              >
                <!-- <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.branch_name }}
                    <span
                      class="status-mark bg-danger-600 media-badge"
                      style="margin-top: 2px; left: -10px"
                    ></span>
                  </div>
                </td>
                <td v-else>{{ r.branch_name }}</td> -->
                <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.staff_name }}
                    <span
                      class="status-mark bg-danger-600 media-badge"
                      style="margin-top: 2px; left: -10px"
                    ></span>
                  </div>
                </td>
                <td v-else>{{ r.staff_name }}</td>

                <td>{{ r.customer_id }}</td>
                <td class="ws-nowrap">
                  {{ r.customer_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.customer_phone_number" />
                </td>
                <td v-if="r.action === 'add'">
                  <span class="label bg-green-400"> {{ r.action }}</span>
                </td>
                <td v-else-if="r.action === 'update'">
                  <span class="label bg-blue-400"> {{ r.action }}</span>
                </td>
                <td v-else-if="r.action === 'delete'">
                  <span class="label bg-danger-400"> {{ r.action }}</span>
                </td>
                <td v-else>
                  <span class="label bg-orange-600"> {{ r.action }}</span>
                </td>

                <td>${{ r.amount }}</td>
                <td v-if="r.credit_log_action_date != null">{{ r.credit_log_action_date }}</td>
                <td v-else>{{ r.created_at }}</td>
                <td style="padding-left:10px; padding-right:10px">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showApp', r.credit_log_action_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isTransactionCredit="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  Staff: {{ r.staff_name }} , <br />
                  CustomerID: {{ r.customer_id }} , <br />
                  CustomerName: {{ r.customer_name }}
                </td>

                <td>
                  <span v-if="r.action === 'add'">
                    <span class="label bg-green-400"> {{ r.action }}</span>
                  </span>
                  <span v-else-if="r.action === 'update'">
                    <span class="label bg-blue-400"> {{ r.action }}</span>
                  </span>
                  <span v-else-if="r.action === 'delete'">
                    <span class="label bg-danger-400"> {{ r.action }}</span>
                  </span>
                  <span v-else>
                    <span class="label bg-orange-600"> {{ r.action }}</span>
                  </span>

                  <br />${{ r.amount }} , <br />
                  <span v-if="r.credit_log_action_date != null">{{
                    r.credit_log_action_date
                  }}</span>
                  <span v-else>{{ r.created_at }}</span>
                  , <br />
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showApp', r.credit_log_action_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-action-log
            :detailData="detailData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-action-log>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewActionLog from './viewActionLog.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-action-log': viewActionLog,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getResults()
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '1',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: 'Staff Name',
        text: 'Staff Name',
        value: '1',
        sortable: true,
        searchable: true,
        name: 'staff_name'
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'customer_id'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_name'
      },
      // {label: "Customer Email", text: 'OrderID', value: '2', sortable: true, searchable: true, name: "customer_email"},
      {
        label: 'Action',
        text: 'Action',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'action'
      },
      {
        label: 'Amount',
        text: 'Amount',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'amount'
      },
      {
        label: 'Log Date',
        text: 'Log Date',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'credit_log_action_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/credit_log_actions',
      logDetailUrl: 'api/credit_log_actions',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      detailData: {
        credit_log_action_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        customer_name: '',
        customer_email: '',
        customer_address: '',
        phone_number: '',
        note: '',
        credit_log_action_date: '',
        base_invoice_number: ''
      },
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      creditLogActionID: [],
      columns: columns,
      sortKey: 'credit_log_action_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_action_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.creditLogActionID.length; i++) {
        if (i < this.creditLogActionID.length - 1) {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/transaction-credit-export?' + arr)
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getCreditLogActionID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { })
    },

    getCreditLogActionID(creditLog) {
      this.creditLogActionID = []
      for (let i = 0; i < creditLog.length; i++) {
        this.creditLogActionID[i] = creditLog[i].credit_log_action_id
      }
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_action_id'
      this.tableData.sortDir = 'dsc'
      this.tableData.column = 'credit_log_action_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_action_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_action_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.detailData = response.data.data
          this.detailData.phone_number = response.data.data.customer_phone_number
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          let companyResult = []
          companyResult = data.data

          this.companyData.company_name = companyResult.company_name
          this.companyData.company_address = companyResult.company_address
          this.companyData.company_email = companyResult.company_email
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/logs/creditLogAction.vue